import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ItemViewComponent } from './item-view.component';
import {
  CanActivateDraftItemView,
  CanActivateItemView,
  ItemResolver,
} from './resolver';

const itemRoutes: Routes = [
  {
    path: 'view',
    pathMatch: 'full',
    canActivate: [CanActivateItemView],
    component: ItemViewComponent,
    resolve: {
      listItem: ItemResolver,
    },
  },
  {
    path: 'view_draft',
    pathMatch: 'full',
    canActivate: [CanActivateDraftItemView],
    component: ItemViewComponent,
    data: { isDraft: true },
    resolve: {
      listItem: ItemResolver,
    },
  },
];

export const itemViewRouting: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(itemRoutes);
